import { PostHogConfig } from 'posthog-js';

const host = window.location.host;
export const isProd =
  host.includes('prod.mediatool') || host.includes('prod.bravo') || host == 'bravo.brkthru.com';
export const isStaging = host.includes('staging.mediatool') || host.includes('staging.bravo');
export const isDev = host.includes('dev.mediatool') || host.includes('dev.bravo');
export const isLocal = host.includes('localhost');

// TODO [ac] we can have a separate key for the production system and determine that via the url.
//  This is the recommended way to manage multiple environments
//  https://posthog.com/tutorials/multiple-environments
export const posthogApiKey = 'phc_fKnThQKaqqsgeVucRqLS0jotj1aNHyC9XrU6LBWvybe';

export const posthogConfig: Partial<PostHogConfig> = {
  api_host: 'https://beacon.bravo.brkthru.com',
  disable_session_recording: false,
  capture_pageview: false,
  capture_exceptions: {
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
    capture_console_errors: false
  },
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: { password: true }
  }
};
